/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_EnhanceInputs */

const cs_enum_enhance = /** @type {(inputs: Enum_EnhanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vylepšení`)
};

const en_enum_enhance = /** @type {(inputs: Enum_EnhanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enhance`)
};

/**
* | output |
* | --- |
* | "Enhance" |
*
* @param {Enum_EnhanceInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_enhance = /** @type {((inputs?: Enum_EnhanceInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_EnhanceInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_enhance(inputs)
	return cs_enum_enhance(inputs)
});